const FLAKECOLORS = [
  {
    NAME: 'HF-45, weiß',
    RGBCODE: '255, 255, 255',
    HEXCODE: '#ffffff',
    ID: 0,
  },
  {
    NAME: 'HF-31, elfenbein',
    RGBCODE: '220, 215, 200',
    HEXCODE: '#dcd7c8',
    ID: 1,
  },
  {
    NAME: 'HF-09, pastellgrau',
    RGBCODE: '220, 220, 220',
    HEXCODE: '#dcdcdc',
    ID: 2,
  },
  {
    NAME: 'HF-21, lichtgrau',
    RGBCODE: '210, 210, 210',
    HEXCODE: '#d2d2d2',
    ID: 3,
  },
  {
    NAME: 'HF-03, steingrau',
    RGBCODE: '200, 205, 215',
    HEXCODE: '#c8cdd7',
    ID: 4,
  },
  {
    NAME: 'HF-02, fenstergrau',
    RGBCODE: '195, 197, 200',
    HEXCODE: '#c3c5c8',
    ID: 5,
  },
  {
    NAME: 'HF-24, beige-grau',
    RGBCODE: '190, 185, 175',
    HEXCODE: '#beb9af',
    ID: 6,
  },
  {
    NAME: 'HF-22, kieselgrau',
    RGBCODE: '187, 180, 165',
    HEXCODE: '#bbb4a5',
    ID: 7,
  },
  {
    NAME: 'HF-29, fossil',
    RGBCODE: '212, 206, 194',
    HEXCODE: '#d4cec2',
    ID: 8,
  },
  {
    NAME: 'HF-43, grau',
    RGBCODE: '145, 145, 145',
    HEXCODE: 919191,
    ID: 9,
  },
  {
    NAME: 'HF-25, eisengrau',
    RGBCODE: '78, 81, 82',
    HEXCODE: null,
    ID: 10,
  },
  {
    NAME: 'HF-46, schwarz',
    RGBCODE: '32, 32, 32',
    HEXCODE: 202020,
    ID: 11,
  },
  {
    NAME: 'HF-49, hellblaub',
    RGBCODE: '135, 182, 200',
    HEXCODE: '#87b6c8',
    ID: 12,
  },
  {
    NAME: 'HF-06, pastellblau',
    RGBCODE: '175, 183, 218',
    HEXCODE: '#afb7da',
    ID: 13,
  },
  {
    NAME: 'HF-39, taubenblau',
    RGBCODE: '123, 158, 166',
    HEXCODE: '#7b9ea6',
    ID: 14,
  },
  {
    NAME: 'HF-33, brilliantblau',
    RGBCODE: '66, 130, 156',
    HEXCODE: '#42829c',
    ID: 15,
  },
  {
    NAME: 'HF-38, königsblau',
    RGBCODE: '0, 103, 170',
    HEXCODE: '#0067aa',
    ID: 16,
  },
  {
    NAME: 'HF-26, violettblau',
    RGBCODE: '22, 76, 150',
    HEXCODE: '#164c96',
    ID: 17,
  },
  {
    NAME: 'HF-23, kobaltblau',
    RGBCODE: '35, 40, 70',
    HEXCODE: 242846,
    ID: 18,
  },
  {
    NAME: 'HF-19, wasserblau',
    RGBCODE: '0, 157, 150',
    HEXCODE: '#009d96',
    ID: 19,
  },
  {
    NAME: 'HF-51, pastellgrün',
    RGBCODE: '215, 222, 182',
    HEXCODE: '#d7deb6',
    ID: 20,
  },
  {
    NAME: 'HF-40, grasgrün',
    RGBCODE: '69, 164, 80',
    HEXCODE: '#45a450',
    ID: 21,
  },
  {
    NAME: 'HF-54, gelbgrün',
    RGBCODE: '96, 170, 66',
    HEXCODE: '#60aa42',
    ID: 22,
  },
  {
    NAME: 'HF-41, oliv',
    RGBCODE: '56, 92, 59',
    HEXCODE: '#385c3b',
    ID: 23,
  },
  {
    NAME: 'HF-42, sandstein',
    RGBCODE: '235, 220, 205',
    HEXCODE: '#ebdccd',
    ID: 24,
  },
  {
    NAME: 'HF-14, neugelb',
    RGBCODE: '225, 190, 120',
    HEXCODE: '#e1be78',
    ID: 25,
  },
  {
    NAME: 'HF-15,sandfarbe',
    RGBCODE: '190, 155, 90',
    HEXCODE: '#be9b5a',
    ID: 26,
  },
  {
    NAME: 'HF-47, orange',
    RGBCODE: '240, 160, 50',
    HEXCODE: '#f0a032',
    ID: 27,
  },
  {
    NAME: 'HF-08, goldenbeige',
    RGBCODE: '210, 145, 60',
    HEXCODE: '#d2913c',
    ID: 28,
  },
  {
    NAME: 'HF-44, havannabraun',
    RGBCODE: '150, 113, 85',
    HEXCODE: 967155,
    ID: 29,
  },
  {
    NAME: 'HF-13, dunkelbraun',
    RGBCODE: '100, 67, 50',
    HEXCODE: 644332,
    ID: 30,
  },
  {
    NAME: 'HF-37, englischrot',
    RGBCODE: '155, 70, 50',
    HEXCODE: '#9b4632',
    ID: 31,
  },
  {
    NAME: 'HF-16/6 mm, rosa',
    RGBCODE: '234, 165, 181',
    HEXCODE: '#eaa5b5',
    ID: 32,
  },
  {
    NAME: 'HF-17/6 mm, violett',
    RGBCODE: '180, 115, 158',
    HEXCODE: '#b4739e',
    ID: 33,
  },
  {
    NAME: 'HF-27,bordoeaux-violett',
    RGBCODE: '140, 47, 72',
    HEXCODE: '#8c2f48',
    ID: 34,
  },
  {
    NAME: 'HF-28, rubinrot',
    RGBCODE: '152, 44, 42',
    HEXCODE: '#982c2a',
    ID: 35,
  },
  {
    NAME: 'HF-50, himbeere',
    RGBCODE: '177, 43, 63',
    HEXCODE: '#b12b3f',
    ID: 36,
  },
  {
    NAME: 'HF-001, korallenrot',
    RGBCODE: '200, 90, 73',
    HEXCODE: '#c85a49',
    ID: 37,
  },
  {
    NAME: 'HF-36, geranienrot',
    RGBCODE: '228, 96, 59',
    HEXCODE: '#e4603b',
    ID: 38,
  },
  {
    NAME: 'HF-35, maisgelb',
    RGBCODE: '247, 206, 0',
    HEXCODE: '#f7ce00',
    ID: 39,
  },
];
export default FLAKECOLORS;
